import PropTypes from 'prop-types'
import { useEffect, useRef } from 'react'
import InputLabel from '../ui/InputLabel'

const Ofertas = ({ values, onChange, vieneDeAdministrar }) => {
  const refPrecio = useRef(null)

  useEffect(() => {
    const conDcto =
      values.porcDcto === 0
        ? values.precioUnitario
        : values.precioUnitario - (values.porcDcto * values.precioUnitario) / 100
    refPrecio.current.value = conDcto
  }, [values.porcDcto, values.precioUnitario])

  return (
    <>
      {!vieneDeAdministrar && (
        <p className="descripcion-cuadro-publicacion">
          Aquí puede incluir una oferta de tiempo limitado para su producto. Las fechas de
          Inicio y finalización son únicamente válidas para la oferta realizada.
        </p>
      )}
      <div className="row">
        <div className="col-12 col-lg-6">
          <InputLabel
            type="number"
            name="porcDcto"
            value={values.porcDcto || 0}
            onChange={(e) => onChange(e, 'num')}
            onFocusSelected
            label="Porcentaje de Descuento: "
            classNameInput="input-text-bordered w-25"
          />
          <i className="fa fa-percent ml-2" aria-hidden="true" />
        </div>
        <div className="col-12 col-lg-6">
          <InputLabel
            name="precioFinal"
            ref={refPrecio}
            readOnly
            label={
              <>
                Precio final de Publicación:
                <i className="fa fa-usd mr-2" aria-hidden="true" />
              </>
            }
            classNameInput="input-text-bordered w-25"
          />
        </div>
        <div className="col-6 col-lg-6">
          <div className="row">
            <div className="col">
              <InputLabel
                type="date"
                name="ofertaDesde"
                classNameInput="input-text-bordered w-40"
                value={values.ofertaDesde || ''}
                onChange={onChange}
                label="Fecha de Inicio: "
                error="Completar Fecha de Inicio Oferta"
              />
            </div>
          </div>
        </div>
        <div className="col-6 col-lg-6">
          <div className="row">
            <div className="col">
              <InputLabel
                type="date"
                name="ofertaHasta"
                classNameInput="input-text-bordered w-40"
                value={values.ofertaHasta || ''}
                onChange={onChange}
                label="Fecha de Finalización: "
                error="Completar Fecha de Finalización Oferta"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

Ofertas.propTypes = {
  values: PropTypes.shape({
    porcDcto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    precioUnitario: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    ofertaDesde: PropTypes.string.isRequired,
    ofertaHasta: PropTypes.string.isRequired
  }).isRequired,
  onChange: PropTypes.func.isRequired,
  vieneDeAdministrar: PropTypes.bool
}

export default Ofertas
